import styled from "styled-components"

import { spacing } from "@minuthq/meatball-ui-react"

import { ParadiseLLMPromptChat } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseLLMPrompChat"
import { ParadiseLLMPromptEditor } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseLLMPromptEditor"
import { TParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"

export function ParadiseLLMActivePrompt({
  prompt,
}: {
  prompt: TParadiseLLMPrompt
}) {
  return (
    <Wrapper>
      <ParadiseLLMPromptEditor prompt={prompt} />
      <ParadiseLLMPromptChat prompt={prompt} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 100%;
  max-height: 80vh;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: ${spacing.M};
`
